import React from "react";

function Spa() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40"
    >
      <path
        d="M25.8167 16.05C25.5167 11.4 23.6334 6.86671 20.1 3.33337C16.5334 6.90004 14.5667 11.4334 14.1834 16.05C16.3167 17.1834 18.2834 18.65 20 20.4334C21.7167 18.6667 23.6834 17.2 25.8167 16.05ZM14.9834 20.4667C14.75 20.3 14.4834 20.15 14.2334 19.9834C14.4834 20.1667 14.75 20.3 14.9834 20.4667ZM25.6834 20.05C25.4667 20.2 25.2334 20.3167 25.0167 20.4834C25.2334 20.3167 25.4667 20.2 25.6834 20.05ZM20 25.75C16.4167 20.2834 10.3 16.6667 3.33337 16.6667C3.33337 25.5334 8.93337 33.0334 16.7167 35.8167C17.7667 36.2 18.8667 36.4834 20 36.6667C21.1334 36.4667 22.2167 36.1834 23.2834 35.8167C31.0667 33.0334 36.6667 25.5334 36.6667 16.6667C29.7 16.6667 23.5834 20.2834 20 25.75Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Spa;
